import { render, staticRenderFns } from "./Sudoku.vue?vue&type=template&id=5c5c9c80&"
import script from "./Sudoku.vue?vue&type=script&lang=ts&"
export * from "./Sudoku.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports